import styled from 'styled-components';

export const OfferWrap = styled.section`
  padding: 1.5rem;
  border-top: 1px solid #efefef;
`;

export const OfferBox = styled.section`
  border-radius: 0.8rem;
  border: solid 1px #e5edf6;
  margin-bottom: 1rem;
`;
export const OfferBoxHdr = styled.div`
  padding: 1.2rem 1.2rem 1.2rem 1.6rem;
  display: flex;
  flex-direction: row;
  align-items: center;
`;
export const HdrTxt = styled.span`
  font-size: 1.4rem;
  color: #141823;
  font-weight: bold;
  padding-left: 1rem;
`;
export const OfferBoxContent = styled.div`
  border-top: 1px solid #efefef;
  padding: 1.2rem 2.4rem;
`;
export const OfferTxt = styled.p(
  props=>`
    font-size: 1.2rem;
    color: ${props.textColor ? props.textColor : '#777'};
`);
export const KnowMoreLink = styled.a`
  font-size: 1.2rem;
`;
export const ImpInfoMsg = styled.p`
  color: #FF6D38;
  font-size: 1.2rem;
  font-weight: 700;
  margin-top: 0.4rem;
`;
export const TextBoxWrap = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: 0.4rem;
  overflow: hidden;
  margin-bottom: 1rem;
`;
export const TextBox = styled.input`
  border-radius: 0.4rem;
  border: solid 1px #dadada;
  padding: 1rem;
  width: 100%;
  font-size: 1.4rem;
  &.error {
    border: 1px solid #ff1515;
    color: #ff1515;
  }
`;
export const TextBoxArrowWrap = styled.span`
  padding: 0.95rem 1rem;
  background: #dcddde;
  margin-left: -0.5rem;
  cursor:pointer;
`;
export const PromoLink = styled.p`
  font-size: 1.4rem;
  padding: 1rem 0;
`;
export const AppliedTag = styled.p`
  background: #e9f6ea;
  color: #2bac36;
  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: 0.3rem;
  padding: 0.8rem;
  cursor:pointer;
  margin-left:1rem; 
`;
export const CloseIcon = styled.span`
  background: #2bac36;
  color: #e9f6ea;
  width: 1.2rem;
  height: 1.2rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  font-weight: bold;
  margin-left: 0.5rem;
`;
export const TagLoader = styled.p`
  display: flex;
  align-items: center;
  flex-direction: row;

  span {
    font-size: 1.2rem;
    color: #2276e3;
    padding-left: 0.5rem;
  }
`;
export const ErrorTxt = styled.p`
  font-size: 1.2rem;
  color: #ff1515;
`;
export const SignInTagsWrap = styled.div`
  width: 100%;
  margin-bottom: 1rem;
  cursor:pointer;
`
